import { render } from "./PotentialDetailsV1.vue?vue&type=template&id=4776731b&scoped=true&lang=pug"
import script from "./PotentialDetailsV1.vue?vue&type=script&setup=true&lang=js"
export * from "./PotentialDetailsV1.vue?vue&type=script&setup=true&lang=js"

import "./PotentialDetailsV1.vue?vue&type=style&index=0&id=4776731b&scoped=true&lang=sass"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4776731b"]])

export default __exports__